export default __webpack_public_path__ + "static/media/36.b1d28b68.jpg";